module.exports = __webpack_public_path__ + "img/home.9ef06d94.png";